import { render, staticRenderFns } from "./RecessConfigEdit.vue?vue&type=template&id=6cda34e4&scoped=true"
import script from "./RecessConfigEdit.vue?vue&type=script&lang=js"
export * from "./RecessConfigEdit.vue?vue&type=script&lang=js"
import style0 from "./RecessConfigEdit.vue?vue&type=style&index=0&id=6cda34e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cda34e4",
  null
  
)

export default component.exports